import React, { Component } from "react";
import { connect } from "react-redux";
import { resetPasswords } from "../../../state/ducks/password/index";
import StaticModal from "../shared/StaticModal";

const validatePasswordForm = ({ oldPassword, newPassword, reNewPassword }) => {
  const errors = {};

  if (!oldPassword) {
    errors.oldPassword = "Eski Şifrenizi Giriniz.";
  }

  if (!newPassword) {
    errors.newPassword = "Yeni Şifre alanını Boş Bırakamazsınız.";
  } else if (newPassword.length < 8) {
    errors.newPassword = "Yeni Şifreniz en az 8 karakter olmalıdır.";
  } else if (newPassword.search(/[a-z]/) < 0) {
    errors.newPassword = "Yeni Şifrenizde en az bir adet Küçük harf bulunmalıdır.";
  } else if (newPassword.search(/[A-Z]/) < 0) {
    errors.newPassword = "Yeni Şifrenizde en az bir adet Büyük harf bulunmalıdır.";
  } else if (newPassword.search(/[0-9]/) < 0) {
    errors.newPassword = "Yeni Şifrenizde en az bir adet Rakam İçermelidir.";
  } else if (newPassword.search(/[!@#$%^&*(_),.?:|<>-]/) < 0) {
    errors.newPassword =
      "Yeni şifrelerinizde en az bir özel karakter (!@#$%^&*(_),.?:|<>-) bulunmalıdır.";
  }

  if (newPassword !== reNewPassword) {
    errors.reNewPassword = "Yeni Şifreleriniz Aynı Olmalıdır.";
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};

class ResetPassword extends Component {
  state = {
    oldPassword: "",
    newPassword: "",
    reNewPassword: "",
    showOldPassword: false,
    showNewPassword: false,
    showReNewPassword: false,
    errors: {},
    shouldAnimateCard: false,
  };

  componentDidMount() {
    this.setState({ shouldAnimateCard: true });
    window.setTimeout(() => this.setState({ shouldAnimateCard: false }), 900);
  }

  togglePasswordVisibility = (field) => {
    this.setState((prevState) => ({
      [field]: !prevState[field],
    }));
  };

  handleFieldChange = (field) => (event) => {
    this.setState({
      [field]: event.target.value,
      errors: {
        ...this.state.errors,
        [field]: "",
      },
    });
  };

  resetPasswords = (event) => {
    event.preventDefault();

    const { oldPassword, newPassword, reNewPassword } = this.state;
    const validation = validatePasswordForm({ oldPassword, newPassword, reNewPassword });

    if (!validation.isValid) {
      this.setState({ errors: validation.errors });
      return;
    }

    this.props.resetPasswords(oldPassword, newPassword);
    this.setState({
      oldPassword: "",
      newPassword: "",
      reNewPassword: "",
      errors: {},
      showOldPassword: false,
      showNewPassword: false,
      showReNewPassword: false,
    });
  };

  renderPasswordField = ({
    id,
    label,
    placeholder,
    value,
    error,
    showPassword,
    showField,
    onChange,
  }) => (
    <div className="t-resetPassword-field">
      <label htmlFor={id} className="t-resetPassword-label">
        {label}
      </label>
      <div
        className={`t-resetPassword-inputWrap${
          error ? " t-resetPassword-inputWrap--error" : ""
        }`}
      >
        <span className="t-resetPassword-inputIcon" aria-hidden="true">
          <i className="t-icon-lock1" />
        </span>
        <input
          id={id}
          type={showPassword ? "text" : "password"}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          autoComplete={id === "eski_sifre" ? "current-password" : "new-password"}
        />
        <button
          type="button"
          className="t-resetPassword-toggle"
          onClick={() => this.togglePasswordVisibility(showField)}
          aria-label={showPassword ? "Şifreyi gizle" : "Şifreyi göster"}
        >
          <i
            className={showPassword ? "t-icon-eye" : "t-icon-eye-blocked"}
            aria-hidden="true"
          />
        </button>
      </div>
      {error && <p className="t-resetPassword-error">{error}</p>}
    </div>
  );

  render() {
    const {
      oldPassword,
      newPassword,
      reNewPassword,
      showOldPassword,
      showNewPassword,
      showReNewPassword,
      errors,
      shouldAnimateCard,
    } = this.state;

    return (
      <div style={{ background: "#ffffff" }}>
        <div className="row" style={{ padding: "3%" }}>
          <div className="col-12">
            <div className="t-memberInfo-pageHeader">
              <h1 className="t-memberInfo-pageTitle">Şifre Belirleme</h1>
              <p className="t-memberInfo-pageSubtitle">
                Hesap güvenliğiniz için mevcut şifrenizi doğrulayarak yeni şifrenizi belirleyin.
              </p>
            </div>

            <article
              className={`t-memberInfo-card t-memberDetail-header--green${
                shouldAnimateCard ? " t-memberInfo-card--enter" : ""
              }`}
            >
              {/* <div className="t-memberInfo-cardHeader">
                <div className="t-memberDetail-headerIcon t-memberInfo-cardIcon">
                  <i className="t-icon-lock1" aria-hidden="true" />
                </div>

                <div className="t-memberInfo-cardHeaderContent">
                  <h2 className="t-memberInfo-cardTitle">Şifre Değiştir</h2>
                  <div className="t-memberInfo-cardBadges">
                    <span className="t-memberDetail-headerBadge">Güvenlik Ayarları</span>
                  </div>
                </div>
              </div> */}

              <form className="t-resetPassword-form" onSubmit={this.resetPasswords} noValidate>
                {this.renderPasswordField({
                  id: "eski_sifre",
                  label: "Eski Şifreniz",
                  placeholder: "Eski şifrenizi giriniz",
                  value: oldPassword,
                  error: errors.oldPassword,
                  showPassword: showOldPassword,
                  showField: "showOldPassword",
                  onChange: this.handleFieldChange("oldPassword"),
                })}

                {this.renderPasswordField({
                  id: "yeni_sifre",
                  label: "Yeni Şifreniz",
                  placeholder: "Yeni şifrenizi giriniz",
                  value: newPassword,
                  error: errors.newPassword,
                  showPassword: showNewPassword,
                  showField: "showNewPassword",
                  onChange: this.handleFieldChange("newPassword"),
                })}

                {this.renderPasswordField({
                  id: "yeni_sifre_tekrar",
                  label: "Yeni Şifreniz Tekrar",
                  placeholder: "Yeni şifrenizi tekrar giriniz",
                  value: reNewPassword,
                  error: errors.reNewPassword,
                  showPassword: showReNewPassword,
                  showField: "showReNewPassword",
                  onChange: this.handleFieldChange("reNewPassword"),
                })}

                <div className="t-resetPassword-actions">
                  <button type="submit" className="t-memberInfo-btn t-memberInfo-btn--primary">
                    <span>Değiştir</span>
                    <i className="t-icon-arrow-right2" aria-hidden="true" />
                  </button>
                </div>
              </form>

              <div className="t-resetPassword-rules">
                <strong>Şifre değiştirme kuralları</strong>
                <ol>
                  <li>
                    Şifreniz en az <strong>8</strong> karakter olmalıdır.
                  </li>
                  <li>
                    Şifrenizde en az <strong>bir tane küçük harf</strong> olmalıdır.
                  </li>
                  <li>
                    Şifrenizde en az <strong>bir tane büyük harf</strong> olmalıdır.
                  </li>
                  <li>
                    Şifrenizde en az <strong>bir tane rakam</strong> bulunmalıdır.
                  </li>
                  <li>
                    Şifrenizde en az{" "}
                    <strong>bir özel karakter (!@#$%^&*(),.?:{}|&lt;&gt;-_)</strong> bulunmalıdır.
                  </li>
                </ol>
              </div>
            </article>
          </div>
        </div>
        <div className="row" style={{ height: 30 }} />
        <StaticModal />
      </div>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  resetPasswords: (oldPassword, newPassword) =>
    dispatch(resetPasswords(oldPassword, newPassword)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
